import {
    AUTOMATE_PURCHASE_ORDER,
    DELETE_ORDER_PLANNING, LIST_ALL_SHIPPED_FTL,
    LIST_ORDER_PLANNING, REFRESH_NEW_PURCHASE_ORDER, REMOVE_PURCHASE_ORDER,
    SAVE_ORDER_PLANNING, STORE_ALL_SHIPPED_FTL,
    STORE_ORDER_PLANNING,
} from '../../constants/orderPlanning';




export const listOrderPlanning = (data) => ({
    type: LIST_ORDER_PLANNING,
    data
});

export const saveOrderPlanning = (data,callback) => ({
    type: SAVE_ORDER_PLANNING,
    data,
    callback
});

export const deleteOrderPlanning = (orderPlanningId) => ({
    type: DELETE_ORDER_PLANNING,
    orderPlanningId,
});

export const storeAllOrderPlanning = (data) => ({
    type: STORE_ORDER_PLANNING,
    data
});

export const automatePurchaseOrder = (data,callback) => ({
    type: AUTOMATE_PURCHASE_ORDER,
    data,
    callback
});

export const refreshNewPurchaseOrder = (data,callback) => ({
    type: REFRESH_NEW_PURCHASE_ORDER,
    data,
    callback
});

export const removePurchaseOrder = (data,callback) => ({
    type: REMOVE_PURCHASE_ORDER,
    data,
    callback
});

export const listShippedFTLs = () => ({
    type: LIST_ALL_SHIPPED_FTL,
});

export const storeAllShippedFTL = (ftl) => ({
    type: STORE_ALL_SHIPPED_FTL,
    ftl
});